<template>
  <div id="menu">
    <div id="child" v-on:click="rout('forKids')">
      <span class="text-h5 text-md-h3 text-center text-uppercase">Детям</span>
    </div>

    <div id="parent" v-on:click="rout('forParents')">
      <span class="text-h5 text-md-h3 text-center text-uppercase"
        >Родителям</span
      >
    </div>

    <div id="specialist" v-on:click="rout('forSpecialist')" >
      <span class="text-h5 text-md-h3 text-center text-uppercase"
        >Программистам <br />
        Дизайнерам</span
      >
    </div>
  </div>
</template>

<script>
import router from "../router/index";

export default {
  methods: {
    rout: function (url) {
      router.push("/" + url);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#menu {
  height: 100%;
  display: grid;
  grid-template-areas:
    "ch p"
    "ch p"
    "ch sp"
    "ch sp";

  @media (max-width: 960px) {
    grid-template-areas:
      "ch ch"
      "p p"
      "sp sp";
  }
  > * {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    cursor: pointer;
    text-decoration: none;
  }

  #child {
    grid-area: ch;
    background: url("../assets/images/forChild.webp") #9bffee;
    background-blend-mode: multiply, normal;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    * {
      transform: scale(1);
      transition: transform 1s ease;
    }
    &:hover {
      background: url("../assets/images/forChild.webp") center no-repeat cover;
      background-blend-mode: normal;
      * {
        transform: scale(1.1);
        transition: transform 1s ease;
      }
    }
  }
  #parent {
    grid-area: p;

    background: url("../assets/images/forParents.webp") #87bffc;
    background-blend-mode: multiply, normal;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
     * {
      transform: scale(1);
      transition: transform 1s ease;
    }
    &:hover {
      background: url("../assets/images/forParents.webp") center no-repeat cover;
      background-blend-mode: normal;
      * {
        transform: scale(1.1);
        transition: transform 1s ease;
      }
    }
  }
  #specialist {
    grid-area: sp;
    background: url("../assets/images/forProgramer.webp") #fabe9e;
    background-blend-mode: multiply, normal;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
     * {
      transform: scale(1);
      transition: transform 1s ease;
    }
    &:hover {
      background: url("../assets/images/forProgramer.webp") center no-repeat cover;
      background-blend-mode: normal;
      * {
        transform: scale(1.1);
        transition: transform 1s ease;
      }
    }
  }
}
</style>